import SharedDeleteModal from "../../../../components/UI/SharedDeleteModal";

const DeleteExamPackageModal = (props) => (
  <SharedDeleteModal {...props} titleKey="clinics_delete_confirmation" />
);

export default DeleteExamPackageModal;
